import React from 'react'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
import { rgba, media, colors } from 'styles'
import { T } from 'components/Translations'
import IntroPopup from './IntroPopup'

const StyledNavigation = styled.nav`
  list-style-type: none;
  margin-top: 0;
  padding-left: 0;
  position: relative; // needed for IntroPopup

  .link {
    display: flex;
    color: ${rgba(colors.mainInverted, 0.75)};
    font-size: 1.8rem;
    font-weight: 300;
    text-decoration: none;
    padding: 1.5rem 0;

    + .link {
      border-top: 0.1rem solid ${rgba(colors.mainInverted, 0.3)};
    }

    &:hover {
      color: ${colors.mainInverted};
    }
    &--active {
      font-weight: 700;
      color: ${colors.mainInverted};
    }
  }
  .text {
    flex: 1;
  }

  .icon {
    margin-left: 1rem;
  }

  ${media.mobile`
    .link {
      font-size: 2.2rem;
      padding: 2rem 0;
    }
  `}
`

const Navigation = ({ routes, className, intro }) => (
  <StyledNavigation className={className}>
    {routes.map(route => (
      <NavLink className="link" key={route.to} activeClassName="link--active" to={route.to} exact={!!route.exact}>
        <T as="div" className="text" label={route.label} />
        {route.icon && <div className="icon">{route.icon}</div>}
      </NavLink>
    ))}
    {intro && routes.find(r => r.to == '/flirt') && <IntroPopup />}
  </StyledNavigation>
)

export default Navigation
